import { compose, deburr, toLower, trim } from 'lodash/fp';
import { UnicodeEntity } from '@mews/enums';

export const normalize = compose(trim, toLower, deburr, (val: string) =>
    val.replaceAll(UnicodeEntity.NoBreakSpace, UnicodeEntity.Space)
);
